(() => {
  const video = document.querySelector('.uc-video-frame video');
  if (!video) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (reduceMotion.matches) {
    video.pause();
    video.removeAttribute('autoplay');
    return;
  }

  const playVideo = () => video.play().catch(() => {});
  playVideo();

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) playVideo();
  });
})();
